import { Link } from "react-router-dom";

const base =
  "inline-flex items-center justify-center gap-2 font-medium rounded-md transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-forest focus-visible:ring-offset-2 disabled:opacity-60 disabled:pointer-events-none";

const variants = {
  primary: "bg-forest text-white hover:bg-forest-dark hover:shadow-lg hover:shadow-forest/20",
  secondary: "bg-transparent text-forest border border-forest hover:bg-forest/5",
  ghostLight:
    "bg-white/10 text-white border border-white/30 hover:bg-white/20 backdrop-blur-sm",
  gold: "bg-gold text-charcoal hover:brightness-95",
};

const sizes = {
  md: "px-6 py-3 text-sm",
  lg: "px-8 py-4 text-base",
  sm: "px-4 py-2 text-sm",
};

export const Button = ({
  as = "button",
  to,
  href,
  variant = "primary",
  size = "md",
  className = "",
  children,
  ...props
}) => {
  const cls = `${base} ${variants[variant]} ${sizes[size]} ${className}`;
  if (to) {
    return (
      <Link to={to} className={cls} {...props}>
        {children}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={cls} {...props}>
        {children}
      </a>
    );
  }
  const Tag = as;
  return (
    <Tag className={cls} {...props}>
      {children}
    </Tag>
  );
};
